import { RouteRoles } from '@/router/role-routes';
import { RouteConfig, NavigationGuardNext } from 'vue-router';
import { global_store, user_store } from '@/store';
import { User } from '@/modules/user/types';
import { validateIntegerParam } from '@/middleware/validateIntegerParam';
import { CommercialOffers } from './types';

const check_is_global_active = (to: unknown, from: unknown, next: NavigationGuardNext) => {
  const { available_pages } = user_store.state.me;

  const active_el = available_pages?.find((el) => el.slug === CommercialOffers.Pages.COMMERCIAL_OFFERS_SLUG);

  if (active_el?.is_global_active) {
    next();
  } else {
    global_store.mutations.SET_INFO_DIALOG_MODAL(true);
    next(User.Pages.PROFILE);
  }
};

const routes: RouteConfig[] = [
  {
    path: `/${CommercialOffers.Pages.COMMERCIAL_OFFERS}`,
    name: CommercialOffers.Pages.COMMERCIAL_OFFERS,
    component: () => import(/* webpackChunkName: "commercial_offers" */ './views/CommercialOffers.vue'),
    meta: {
      access_roles: RouteRoles[CommercialOffers.Pages.COMMERCIAL_OFFERS],
    },
    beforeEnter: check_is_global_active,
  },
  {
    path: `/${CommercialOffers.Pages.COMMERCIAL_OFFERS}/${CommercialOffers.Pages.NEW_OFFER}`,
    name: CommercialOffers.Pages.NEW_OFFER,
    component: () => import(/* webpackChunkName: "commercial_offers" */ './views/NewOffer.vue'),
    meta: {
      access_roles: RouteRoles[CommercialOffers.Pages.COMMERCIAL_OFFERS],
    },
    beforeEnter: check_is_global_active,
  },
  {
    path: `/${CommercialOffers.Pages.OFFER_DETAIL}/:id`,
    name: CommercialOffers.Pages.OFFER_DETAIL,
    beforeEnter: (to, from, next) => {
      validateIntegerParam('id');
      check_is_global_active(to, from, next);
    },
    component: () => import(/* webpackChunkName: "commercial_offers" */ './views/CommercialOfferDetail.vue'),
    meta: {
      access_roles: RouteRoles[CommercialOffers.Pages.OFFER_DETAIL],
    },
    // beforeEnter: check_is_global_active,
  },
  {
    path: `/${CommercialOffers.Pages.COMMERCIAL_OFFERS}/${CommercialOffers.Pages.NEW_OFFER_TEMPLATE}`,
    name: CommercialOffers.Pages.NEW_OFFER_TEMPLATE,
    component: () => import(/* webpackChunkName: "commercial_offers" */ './views/NewOfferTemplate.vue'),
    meta: {
      access_roles: RouteRoles[CommercialOffers.Pages.COMMERCIAL_OFFERS],
    },
    beforeEnter: check_is_global_active,
  },
  {
    path: `/${CommercialOffers.Pages.COMMERCIAL_OFFERS}/${CommercialOffers.Pages.OFFER_TEMPLATE}/:id`,
    name: CommercialOffers.Pages.OFFER_TEMPLATE,
    component: () => import(/* webpackChunkName: "commercial_offers" */ './views/OfferTemplateDetail.vue'),
    meta: {
      access_roles: RouteRoles[CommercialOffers.Pages.COMMERCIAL_OFFERS],
    },
    beforeEnter: check_is_global_active,
  },
  {
    path: `/${CommercialOffers.Pages.COMMERCIAL_OFFERS}/${CommercialOffers.Pages.OFFER_TEMPLATE}/:id/edit`,
    name: CommercialOffers.Pages.EDIT_OFFER_TEMPLATE,
    component: () => import(/* webpackChunkName: "commercial_offers" */ './views/NewOfferTemplate.vue'),
    meta: {
      access_roles: RouteRoles[CommercialOffers.Pages.COMMERCIAL_OFFERS],
    },
    beforeEnter: check_is_global_active,
  },
  {
    path: `/${CommercialOffers.Pages.OFFER_DETAIL}/:id/edit`,
    name: CommercialOffers.Pages.EDIT_OFFER,
    component: () => import(/* webpackChunkName: "commercial_offers" */ './views/NewOffer.vue'),
    meta: {
      access_roles: RouteRoles[CommercialOffers.Pages.COMMERCIAL_OFFERS],
    },
    beforeEnter: check_is_global_active,
  },
];

export default routes;
